import { useCallback } from 'react';
import Script from 'next/script';
import styles from './styles.module.scss';

// OneTrust is a third party tool used by the Legal team as a CMS for the legal content pages
// See list of pages: https://app.onetrust.com/privacy-policy/notices
interface OneTrustContentProps {
  documentID: string;
}

const oneTrustHost = 'https://privacyportal-cdn.onetrust.com';

export const OneTrustContent = ({ documentID }: OneTrustContentProps) => {
  /**
   * content will be loaded after the page has been loaded. this callback will
   * scroll the user to content after the content has loaded.
   */
  const legalContentRefCallback = useCallback<(node: HTMLDivElement) => void>(
    legalContentNode => {
      const urlFragment = window.location.hash;

      if (legalContentNode && urlFragment) {
        const observer = new MutationObserver((_, observerRef) => {
          const anchorElement = document.querySelector(urlFragment);

          if (anchorElement) {
            // Prevent browser from scrolling back to its stored location
            if (window.history.scrollRestoration) {
              window.history.scrollRestoration = 'manual';
            }

            anchorElement.scrollIntoView();
          }
          observerRef.disconnect();
        });

        // Watches for changes made to legalContentNode's children list
        // When new children are added, function passed to MutationObserver is called
        observer.observe(legalContentNode, { childList: true });
      }
    },
    [],
  );

  return (
    <article className={styles.container}>
      <div id={`otnotice-${documentID}`} ref={legalContentRefCallback} />

      <Script
        src={`${oneTrustHost}/privacy-notice-scripts/otnotice-1.0.min.js`}
        type="text/javascript"
        id="otprivacy-notice-script"
        dangerouslySetInnerHTML={{
          __html:
            'settings="eyJjYWxsYmFja1VybCI6Imh0dHBzOi8vcHJpdmFjeXBvcnRhbC5vbmV0cnVzdC5jb20vcmVxdWVzdC92MS9wcml2YWN5Tm90aWNlcy9zdGF0cy92aWV3cyJ9";',
        }}
        onReady={() => {
          if (window.OneTrust) {
            window.OneTrust.NoticeApi.Initialized.then(() => {
              window.OneTrust.NoticeApi.LoadNotices([
                `${oneTrustHost}/4660cbb2-18c0-498c-ba43-1ca2634f0a42/privacy-notices/${documentID}.json`,
              ]);
            });
          }
        }}
      />
    </article>
  );
};
